import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import SurveyPage from './pages/SurveyPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminQuestions from './pages/AdminQuestions';
import AdminResponses from './pages/AdminResponses';
import AdminSettings from './pages/AdminSettings';
import AdminInvitations from './pages/AdminInvitations';
import AdminAgents from './pages/AdminAgents';
import AdminProfile from './pages/AdminProfile';
import AgentDashboard from './pages/AgentDashboard';
import ThankYouPage from './pages/ThankYouPage';
import InvitationPage from './pages/InvitationPage';

function App() {
  return (
    <Router>
      <Toaster position="top-center" toastOptions={{
        style: { fontFamily: 'Inter, sans-serif', fontSize: '14px' }
      }} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/enquete" element={<SurveyPage />} />
        <Route path="/merci" element={<ThankYouPage />} />
        <Route path="/invitation/:token" element={<InvitationPage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/questions" element={<AdminQuestions />} />
        <Route path="/admin/responses" element={<AdminResponses />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/invitations" element={<AdminInvitations />} />
        <Route path="/admin/agents" element={<AdminAgents />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/agent" element={<AgentDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
